<template>
  <nav class="navbar app-navbar navbar-toggleable-md">
    <div class="navbar-brand-container d-flex align-items-center justify-content-start">
      <a class="navbar-brand" @click="moveToProject">
        <i class="i-keylogs"></i>
     </a>
    </div>

    <div class="row navbar-container">

      <div class="menu-icon-container d-flex align-items-center justify-content-center justify-content-lg-start col">
         <!-- @mouseover="hoverSidebar(true)" -->
        <a class="menu-icon i-menu-expanded" href="#" @click.prevent="toggleSidebarClick(false)" v-if="sidebarOpened"></a>
        <a class="menu-icon i-menu-collapsed" href="#" @click.prevent="toggleSidebarClick(true)" v-else></a>
      </div>

      <div class="offset-lg-9"></div>
      <div class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center">
         <a href="https://keylogs.io/blog/tutorials" target="blank" title="Keylogs Tutorials" class="tutorial-link">
            <span class="fa-stack">
              <i class="fa fa-question fa-stack-1x"></i>
            </span>
         </a>
      </div>
      <div class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center" v-dropdown.closeOnMenuClick>
        <a class="nav-link dropdown-toggle d-flex align-items-center justify-content" href="#" @click.prevent="closeMenu">
          <span class="avatar-container">
            <img :src="image" :title="user.name" />
          </span>
        </a>
        <div class="dropdown-menu last">
          <div class="dropdown-menu-content">
            <div class="dropdown-item plain-link-item">
              <router-link class="plain-link white" to='/profile'>Profile</router-link>
            </div>
            <div class="dropdown-item plain-link-item" v-if="user.mainuser">
              <router-link class="plain-link white" to='/subscription'>Subscription</router-link>
            </div>
            <div class="dropdown-item plain-link-item mobile-only">
              <a class="plain-link white" href="https://keylogs.io/blog/tutorials" target="blank">Tutorials</a>
            </div>
            <div class="dropdown-item plain-link-item">
              <a class="plain-link" @click="logout">Logout</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
    import axios from 'axios'
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    import Dropdown from 'directives/Dropdown'

    export default {
      name: 'navbar',
      directives: {
        dropdown: Dropdown
      },
      data () {
        return {
          user: {
            image: 'static/default-user.svg'
          },
          image: 'static/default-user.svg'
        }
      },
      async created () {
        this.$store.dispatch('isLoggedIn').then(response => {
          if (response) {
            try {
              axios.get(`user`).then((user) => {
                this.user = user.data
                this.image = this.user.image || 'static/default-user.svg'
                // this.user.name = this.user.name || ''
                localStorage.setItem('user', JSON.stringify(this.user))
                if (window.$crisp) {
                  window.$crisp.push(['set', 'user:email', this.user.email])
                  window.$crisp.push(['set', 'user:nickname', [this.user.name || this.user.email]])
                  if (this.user.image) {
                    window.$crisp.push(['set', 'user:avatar', [this.user.image]])
                  } else {
                    setTimeout(() => {
                      if (window.$crisp) {
                        this.image = window.$crisp.get('user:avatar') || 'static/default-user.svg'
                      }
                    }, 2000)
                  }
                }
              })
            } catch (e) {
              console.log(e)
              this.show = false
              this.errors.push(e)
            }
          }
        })
      },
      computed: mapGetters([
        'sidebarOpened',
        'toggleWithoutAnimation',
        'isLoggedIn'
      ]),
      methods: {
        ...mapActions([
          'closeMenu',
          'toggleSidebar',
          'toggleSidebarClick',
          'hoverSidebar',
          'isToggleWithoutAnimation',
          'logout'
        ]),
        moveToProject () {
          axios.get(`projects`).then((res) => {
            if (res.data.length < 1) this.$router.push('/newproject')
            else if (res.data) {
              this.$router.push('/project/' + res.data[0]._id + '/dash')
            }
          })
        }
      }
    }
</script>

<style lang="scss">
    @import "../../../sass/_variables.scss";
    @import "../../../../node_modules/bootstrap/scss/mixins/breakpoints";
    @import "../../../../node_modules/bootstrap/scss/variables";
    .navbar.app-navbar {
        .navbar-container {
            width: 100%;
            height: 100%;
            margin: 0;
        }
        height: $top-nav-height;
        padding-left: $nav-padding-left;
        padding-right: $nav-padding-right;
        background-color: $top-nav-bg;
        .avatar-container {
            display: inline-block;
            width: 45px;
            height: 45px; // background-color: white;
            border-radius: 50%; // border: 2px solid $lighter-gray;
            overflow: hidden;
            img {
                height: 100%;
                width: 100%;
            }
        }
        .menu-icon-container {
            padding: 0;
            font-size: $font-size-base;
        }
        .navbar-brand-container {
            position: absolute;
            z-index: 3;
            height: 100%;
            left: $navbar-brand-container-left;
            top: 0;
        }
        .nav-item {
            padding: 0;
            height: 100%;
        }
        .tutorial-link {
             border: 2px solid #2CE8B5;
             border-radius: 50%;
              display:initial;
         }
         .mobile-only {
            display:none
         }
         .white {
            color:#fff
         }
        .dropdown.navbar-dropdown {
            .dropdown-toggle {
                padding: 0;
                &:after {
                    display: none;
                }
            }
            &.show {
                @include media-breakpoint-up(lg) {
                    .dropdown-menu {
                        left: auto;
                        right: 0;
                    }
                }
                &:after {
                    position: absolute;
                    bottom: -$dropdown-show-b;
                    right: calc(50% - 10px);
                    width: 0;
                    height: 0;
                    display: block;
                    content: '';
                    border-left: 10px solid transparent;
                    border-right: 10px solid transparent;
                    border-bottom: 10px solid $darkest-gray;
                }
            }
            .dropdown-menu {
                // margin-top: $dropdown-show-b;
                // padding-top: 0;
                width: 100%;
                margin-top: -50px;
                padding-top: 68px;
            }
            .dropdown-item {
                height: $navbar-dd-item-height;
                cursor: pointer;
                font-size: $font-size-base;
                &:hover,
                &:active,
                &:focus,
                &.active {
                    outline: none;
                }
                &.plain-link-item {
                    color: $brand-primary;
                    &:hover,
                    &:active,
                    &:focus {
                        background: $dropdown-background;
                    }
                    .plain-link {
                        text-decoration: none;
                    }
                }
            }
        }
        .notify {
            position: relative;
            &::after {
                content: '';
                position: absolute;
                right: -6px;
                top: -6px;
                background-color: $brand-primary;
                height: 12px;
                width: 12px;
                border-radius: 50%;
            }
        }
        .i-nav-notification.notify::after {
            right: -4px;
            top: 0;
        }
        @include media-breakpoint-down(md) {
            height: $top-mobile-nav-height;
            padding: $nav-mobile-pt $nav-mobile-padding-h $nav-mobile-pb $nav-mobile-padding-h;
            .dropdown-menu {
                margin-top: $dropdown-show-b;
                padding-top: 0;
             }
            .navbar-brand-container {
                width: $nav-mobile-brand-width;
                top: $nav-mobile-brand-top;
                left: $nav-mobile-brand-left;
                height: auto;
                .navbar-brand {
                    height: $font-size-smaller;
                    padding: 0;
                    font-size: $font-size-smaller;
                }
            }
            .tutorial-link {
        display:none;
    }
    .mobile-only {
      display: -webkit-box;
display: -ms-flexbox;
display: flex;
    }
            .dropdown.navbar-dropdown {
                &.show {
                    display: flex;
                    &:after {
                        bottom: -$dropdown-mobile-show-b;
                        z-index: 2;
                    }
                    .dropdown-menu {
                        margin-top: $dropdown-mobile-show-b;
                        left: auto;
                        padding-top: 0;
                        &.last {
                            right: 0;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/navbar/Navbar.vue